import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getAdminMenuType, addAdminMenuType, deleteAdminMenuType, updateAdminMenuType } from "../../redux/actions/adminMenuType.action";
import { getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, getAllCompany } from "../../redux/actions/companyAccess";
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import { logColumns, adminMenuTypeColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';

const { TabPane } = Tabs;

export default function AdminMenuType({ token }) {
    TabTitle("Admin Menu Type")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const adminMenuTypeNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [adminMenuTypeObj, setadminMenuTypeObj] = useState(null);
    const dispatch = useDispatch();
    const { adminMenuType, getDemoDefaultCompany, companyAccess, companyAll, log, userRights } = useSelector(state => state)
    
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [adminMenuTypeName, setadminMenuTypeName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

 


    useEffect(() => {
        dispatch(getAdminMenuType(token, menuId));
        
        dispatch(getLog(token, { admin_menu_type: "admin_menu_type"}))
      }, [token]);
    

    
    
    


    useEffect(() => {
        dispatch(getAdminMenuType(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (adminMenuTypeObj) {
            setFormState('view')
            form.setFieldsValue({
                id: adminMenuTypeObj.menu_type_id,
                adminMenuType: adminMenuTypeObj.menu_type_name,
                active: adminMenuTypeObj.is_active
            });
            setadminMenuTypeName(adminMenuTypeObj.menu_type_name)
            setCheck(adminMenuTypeObj.is_active)
            dispatch(getCompanyAccess(token, adminMenuTypeObj.menu_type_id, menuId))

        }
    }, [adminMenuTypeObj]);

    useEffect(() => {
        if (adminMenuTypeName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [adminMenuTypeName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            
            dispatch(getLog(token, { admin_menu_type: "admin_menu_type"}))
        }
    }


    const formSave = () => {
        if (formState === "add") {
            dispatch(addAdminMenuType(token, { adminMenuTypeName, check }, menuId)).then((res) => {

                if (res.type === "ADD_ADMIN_MENU_TYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_ADMIN_MENU_TYPE_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    notification("success", "Admin Menu Type created", "Admin Menu Type created successfully!");
                    form.setFieldsValue({
                        itemType: ""
                    })
                    setFormState("")
                    
                    setadminMenuTypeName("")
                    setadminMenuTypeObj(null)
                }
                dispatch(getAdminMenuType(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateAdminMenuType(token, { adminMenuTypeName, check }, adminMenuTypeObj.menu_type_id)).then((res) => {
                if (res.type === "UPDATE_ADMIN_MENU_TYPE_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_ADMIN_MENU_TYPE_SUCCESS") {
                    notification("success", "Admin Menu Type update", "Record updated successfully")
                }
                dispatch(getAdminMenuType(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (adminMenuTypeObj) {
            dispatch(deleteAdminMenuType(token, adminMenuTypeObj.menu_type_id)).then((res) => {
                if (res.type === "DELETE_ADMIN_MENU_TYPE_SUCCESS") {
                    notification("success", "Gender Category deleted", "Gender Category deleted successfully!");
                }
                if (res.type === "DELETE_ADMIN_MENU_TYPE_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    itemType: ""
                })
                
                setadminMenuTypeName("")
                setadminMenuTypeObj(null)
                setFormState('')
                dispatch(getAdminMenuType(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            adminMenuTypeNameInput.current.focus();
            form.setFieldsValue({
                adminMenuType: ""
            })
            setCheck(true)
            setadminMenuTypeName("")
            setadminMenuTypeObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Admin Menu Type"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="adminMenuType" adminMenuTypeObj={setadminMenuTypeObj} scrollX={"20rem"} scroll={602} perPage={25} source={adminMenuType?.payload?.data} col={adminMenuTypeColumns} paginate load={adminMenuType.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >  
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 12 }}
                                        >
                                             <div className='customRow styleFormUpper ' >
                                            {adminMenuTypeObj !== null && !(formState === "add") &&
                                            <div className='customCols slc'>
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                    initialValue={form.getFieldValue().id}
                                                >
                                                    <Input  size='small' className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                                </div>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="AdminMenu Type"
                                                name="adminMenuType"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().adminMenuType}
                                            >

                                                <Input  size='small'   disabled={!(formState === "add" || formState === "edit")} ref={adminMenuTypeNameInput} onChange={(e) => setadminMenuTypeName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                name="active"
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
                                        </Form>
                                
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                         
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                   
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}